export const backgrounds = {
  'ambient-1': {
    dark: 'linear-gradient()',
    light: 'linear-gradient()',
  },
};
